import { FlowDurationUnits } from 'flow-schema';

import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockTextField } from '../../ConfigFields/TextField';

export function CallbackFormFields() {
  return (
    <>
      <BlockTextField
        fieldName="config.message"
        label="Message"
        required
        helperText="Enter message to be sent to the external service."
      />
      <BlockDurationField
        fieldName="config.waitTime"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[FlowDurationUnits.Minutes, FlowDurationUnits.Seconds]}
        toggleLabel="Wait time"
        valueLabel="Time to wait before sending callback"
        valueHelperText="Enter the time to wait for a callback."
      />
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[
          FlowDurationUnits.Hours,
          FlowDurationUnits.Minutes,
          FlowDurationUnits.Seconds,
        ]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
        valueHelperText="Enter the time to wait before timing out on callback."
      />
    </>
  );
}
